import 'react-app-polyfill/stable';

import { createRoot } from 'react-dom/client';

import App from './App';
import useAnalyticStore from './store/analyticStore/useAnalyticStore';
import useAttributionStore from './store/attributionStore/useAttributionStore';
import useErrorReportingStore from './store/errorReportingStore/useErrorReportingStore';
import useLeadChannelStore from './store/leadChannelStore/useLeadChannelStore';
import useParameterStore from './store/parameterStore/useParameterStore';
import useThemeStore from './store/themeStore/useThemeStore';

export const REACT_ROOT_NODE_ID = 'checklight-root';

const renderApplication = (): void => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  createRoot(document.getElementById(REACT_ROOT_NODE_ID)!).render(<App />);
};

// initialize error reporting before rendering the application
useErrorReportingStore.getState().init();

const urlSearchParams = new URLSearchParams(window.location.search);

// initialize parameter store states based on URL search params.
// loaders run before this, so they read the URL themselves rather than this store
useParameterStore.getState().setFromURLSearchParams(urlSearchParams);

// initialize attribution store based on URL and search params
useAttributionStore.getState().setFromURLSearchParams(urlSearchParams);
useAttributionStore.getState().setInitialURL(new URL(window.location.href));

// publish theme tokens as CSS custom properties before the first paint
useThemeStore.getState().publishCssVariables();

// adopt the brand of whatever vehicle the user opens
useLeadChannelStore.getState().bindCurrentVehicleListener();

// render the application
renderApplication();

// initialize analytic elements tracking
useAnalyticStore.getState().bindElementAnalyticsListeners();
